export default {
  searchBoxMilo: `${process.env.PUBLIC_URL}/images/wgw/wgw-milo-with-logo.png`,
  searchBoxMiloHand: `${process.env.PUBLIC_URL}/images/wgw/milo-hand.png`,
  materialGroupImages: `${process.env.PUBLIC_URL}/images/wgw/icon_v3.png`,
  testCoachling: `${process.env.PUBLIC_URL}/images/coachlings/find_image.png`,
  searchIcon: `${process.env.PUBLIC_URL}/images/icons/search.png`,
  closeIcon: `${process.env.PUBLIC_URL}/images/icons/close_dark.png`,

  icons: {
    leftArrow: `${process.env.PUBLIC_URL}/images/icons/left-arrow.png`,
    marker: `${process.env.PUBLIC_URL}/images/icons/marker.png`,
    phone: `${process.env.PUBLIC_URL}/images/icons/phone.png`,
    email: `${process.env.PUBLIC_URL}/images/icons/mail.png`,
    sliderLeftArrow: `${process.env.PUBLIC_URL}/images/icons/slider-left-arrow.png`,
    sliderRightArrow: `${process.env.PUBLIC_URL}/images/icons/slider-right-arrow.png`,
    dropDown: `${process.env.PUBLIC_URL}/images/icons/icon_dropdown.png`
  }
};
